import { render, staticRenderFns } from "./ProfileRole.vue?vue&type=template&id=f40fba54&"
import script from "./ProfileRole.vue?vue&type=script&lang=js&"
export * from "./ProfileRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports